"use client";

import { OTPInput } from "@watt/ui/components/ui/otp-input";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type React from "react";
import { useVerification } from "./verification-context";

export interface VerificationOTPProps {
  className?: string;
  onComplete?: (code: string) => void;
  ref?: React.Ref<HTMLDivElement>;
}

export function VerificationOTP({
  className,
  onComplete,
  ref
}: VerificationOTPProps) {
  const { state, config, actions } = useVerification();
  const otpLength = config.otpLength ?? 6;

  const handleChange = (value: string) => {
    actions.updateOtpCode(value);
    // Clear error when user starts typing
    if (state.error) {
      actions.clearError();
    }
  };

  const handleComplete = async (value: string) => {
    await actions.verify(value);
    onComplete?.(value);
  };

  return (
    <div className={cn("w-full", className)} ref={ref}>
      <OTPInput
        disabled={state.isVerifying || config.disabled}
        maxLength={otpLength}
        onChange={handleChange}
        onComplete={handleComplete}
        value={state.otpCode}
      />
    </div>
  );
}
